import moment from 'moment'

const formatDate = (value, formatting, _) => {
  return moment.utc(value).local().format(formatting)
}

export { formatDate }
